<template>
    <div class="floor style-4">
        <!-- 楼层标题 -->
        <div class="floor_title">
            <div class="floor_title_content">
                <span class="floor_title_border"></span>
                <span class="floor_title_content_index">{{ floorConfig.title || "3F" }}</span>
                <span class="floor_title_content_text">{{ floorConfig.subTitle || "NiuShop" }}</span>
            </div>
            <!-- 右侧分类链接区 -->
            <div class="other-title" v-if="floorConfig.titleLink">
                <router-link :to="floorConfig.titleLink.url">{{ floorConfig.titleLink.content }} <i class="iconfont iconarrow-right"></i></router-link>
            </div>
        </div>
        <!-- 楼层内容区 -->
        <div class="floor-content">
            <cargo-item :cargo="item" v-for="(item, index) in skuList" :key="index" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import CargoNormal from "@/components/cargo/CargoNormal"
    import { floorGoods, goodsSkuList } from "@/api/goods/goods"
    import CargoItem from "./cargo_item_2"

    export default {
        name: "style4",
        components: {
            CargoNormal,
            CargoItem
        },
        props: {
            config: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                floorConfig: {
                    validated: false,
                    rightCargos: []
                },
                skuList: []
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
            this.getSkuList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            handleCargoClick(skuId) {
                if (skuId) {
                    this.$router.pushToTab(`/sku-${skuId}`)
                }
            },
            getSkuList() {
                const sku_ids = this.floorConfig.rightCargos
                    .map(item => {
                        return item.sku_id
                    })
                    .toString()

                goodsSkuList({ sku_ids })
                    .then(res => {
                        this.skuList = res.data
                    })
                    .catch(err => {})
            }
        },
        watch: {
            config: {
                handler: function(curr) {
                    if (curr && curr.rightCargos) {
                        this.floorConfig = { ...curr, validated: true }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floor {
        &_title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 20px;
            &_border {
                display: inline-block;
                width: 5px;
                height: 28px;
                background-color: $base-color;
                margin-right: 12px;
                vertical-align: top;
            }
        
            &_content {
                font-size: 20px;
                padding-top: 10px;
                padding-bottom: 10px;
                height: 48px;
                line-height: 28px;
                // border-bottom: 1px solid transparentize($color: $ns-text-color-black, $amount: 0.9);
        		box-sizing: border-box;
        
                &_index {
                    display: inline-block;
                    color: $ns-text-color-black;
                    padding-right: 8px;
                    font-weight: 600;
                }
        
                &_text {
        			font-weight: 600;
        			display: inline-block;
                    color: $base-color;
                }
            }
            .other-title {
                a {
                    color: #838383;
        
                    i {
                        font-size: 14px;
                    }
        			
        			&:hover {
        				color: $base-color;
        			}
                }
            }
        }
        .floor-content {
            display: flex;
            flex-wrap: wrap;
        }
    }
</style>
